const HTTP_PROTOCOL_PREFIX = 'http://';
const HTTPS_PROTOCOL_PREFIX = 'https://';

export const ensureHttpsUrl = (value?: string | null): string => {
  if (!value) {
    return '';
  }

  if (value.startsWith(HTTP_PROTOCOL_PREFIX)) {
    return `${HTTPS_PROTOCOL_PREFIX}${value.slice(HTTP_PROTOCOL_PREFIX.length)}`;
  }

  if (value.startsWith('//')) {
    return `${HTTPS_PROTOCOL_PREFIX}${value}`;
  }

  return value;
};

export const normalizeHttpsUrls = <T>(value: T): T => {
  if (typeof value === 'string') {
    return ensureHttpsUrl(value) as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => normalizeHttpsUrls(item)) as T;
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, item]) => [key, normalizeHttpsUrls(item)]),
    ) as T;
  }

  return value;
};
